import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2835151d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onboarding-card_header flex" }
const _hoisted_2 = { class: "onboarding-card_header_title" }

import {SvgIcon} from '@/logged/common/ui';
    import {useMediaQuery} from '@malt/joy-entrypoint/src/vue/use';
    import {storeToRefs} from 'pinia';
    import {watch, ref, nextTick, computed} from 'vue';
    import {number, object} from 'vue-types';
    import {NewUserOnboardingCard, useOnboardingNewUser} from '..';

    const selectTimeOut: number | null = null;

    
export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingNewUserCard',
  props: {
        card: object<NewUserOnboardingCard>().isRequired,
        index: number().isRequired,
    },
  setup(__props) {

const props = __props;

    

    const onBoardingStore = useOnboardingNewUser();
    const {selectedOnboardingCardIndex} = storeToRefs(onBoardingStore);

    const onboardingCardRef = ref<HTMLDivElement>();

    const {matchMedia} = useMediaQuery();

    const getIconSize = computed(() => {
        if (matchMedia.value.max.Xs) {
            return 24;
        } else {
            return 18;
        }
    });

    const isSelected = computed(() => selectedOnboardingCardIndex.value === props.index);

    watch(isSelected, onSelectedChange, {immediate: true});

    async function onSelectedChange() {
        await nextTick();
        const panel = onboardingCardRef.value;
        const transitionDuration = 300;
        if (panel) {
            if (selectTimeOut) {
                clearTimeout(selectTimeOut);
            }
            if (!isSelected.value) {
                // Panel is closing
                panel.style.maxHeight = `${panel.scrollHeight}px`;
                setTimeout(() => {
                    panel.style.maxHeight = `0`;
                }, 1);
            } else {
                // Panel is opening

                panel.style.maxHeight = `${panel.scrollHeight}px`;
                setTimeout(() => {
                    panel.style.maxHeight = 'none';
                }, transitionDuration);
            }
        }
    }

    function handleCardClick() {
        selectedOnboardingCardIndex.value = props.index;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["onboarding-card flex", {isSelected: isSelected.value, isMobile: _unref(matchMedia).max.Xs}]),
    onClick: handleCardClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(SvgIcon), {
        size: getIconSize.value,
        class: "onboarding-card_header_icon",
        src: __props.card.icon,
        active: isSelected.value
      }, null, 8, ["size", "src", "active"]),
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.card.title), 1)
    ]),
    _createElementVNode("div", {
      ref_key: "onboardingCardRef",
      ref: onboardingCardRef,
      class: "onboarding-card_description"
    }, _toDisplayString(__props.card.description), 513)
  ], 2))
}
}

})